import gql from 'graphql-tag';
import {PersonDeletionDetailFragment} from '__generated__/graphql/types';

/** Looks up display fields for the records selected by the read-only person deletion preview. */
export default gql`
    query PersonDeletionDetails($personIDs: [ID!]!, $credentialIDs: [ID!]!, $passengerIDs: [ID!]!, $pobIDs: [ID!]!, $whiteListIDs: [ID!]!, $nonPreferredIDs: [ID!]!, $listCustomerIDs: [ID!]!, $rigIDs: [ID!]!, $quartersIDs: [ID!]!) {
        persons: resolve_entity_ids(ids: $personIDs, typename: "Person") { ...PersonDeletionDetail }
        credentials: resolve_entity_ids(ids: $credentialIDs, typename: "Credential") { ...PersonDeletionDetail }
        passengers: resolve_entity_ids(ids: $passengerIDs, typename: "PaxNode") { ...PersonDeletionDetail }
        pob: resolve_entity_ids(ids: $pobIDs, typename: "PobNode") { ...PersonDeletionDetail }
        whitelists: resolve_entity_ids(ids: $whiteListIDs, typename: "WhiteList") { ...PersonDeletionDetail }
        nonPreferredLists: resolve_entity_ids(ids: $nonPreferredIDs, typename: "NonPreferred") { ...PersonDeletionDetail }
        rigs: resolve_entity_ids(ids: $rigIDs, typename: "Rig") { ...PersonDeletionDetail }
        quarters: resolve_entity_ids(ids: $quartersIDs, typename: "QuartersNode") { ...PersonDeletionDetail }
        listCustomers: resolve_entity_ids(ids: $listCustomerIDs, typename: "Customer") {
            __typename _id
            ... on Customer { name }
        }
    }
    fragment PersonDeletionDetail on Entity {
        __typename _id classType
        ... on Person { deletedTs firstName lastName }
        ... on Credential { deletedTs type expiration }
        ... on PaxNode { deletedTs nodeState checkInType scheduledFlightDate currentCarrierKey
            customerID { _id name }
            tpID { _id name }
            employerID { _id name }
            currentCarrierID {
                _id
                desig
                state
                scheduledFlightDate
                customerID { _id name }
                tpID { _id name }
            }
        }
        ... on PobNode { deletedTs firstName lastName
            customerID { _id }
            employerID { _id }
            pobTransporter: tpID { _id }
            lastKnownController { _id name }
            currentCarrierID {
                ... on FlightNode { _id }
                ... on BoatNode { _id }
            }
        }
        ... on Rig { deletedTs name }
        ... on QuartersNode { deletedTs name quartersType: type }
    }
`;
export type DeletionDetail = PersonDeletionDetailFragment;
